import React from 'react';
import { MessageContentWrapper } from './MessageContentWrapper';

interface CodeBlock {
    language: string;
    code: string;
}

export const CodeBlockDisplay = ({ codeBlocks }: { codeBlocks: CodeBlock[] }) => {
    return (
        <MessageContentWrapper>
            <div className='caption-1-bold text-gray mb-3'>Code Examples:</div>
            <div className='space-y-3'>
                {codeBlocks.map((block, index) => (
                    <div
                        key={index}
                        className='border-subtle bg-neutral-dark overflow-hidden rounded-lg border shadow-sm'
                    >
                        <div className='border-secondary bg-neutral-dark border-b px-3 py-2'>
                            <span className='caption-2-bold text-light tracking-wide uppercase'>{block.language}</span>
                        </div>
                        <pre className='caption-1-regular text-light overflow-x-auto p-3'>
                            <code>{block.code}</code>
                        </pre>
                    </div>
                ))}
            </div>
        </MessageContentWrapper>
    );
};
